import { TableSortLabel, Tooltip, Typography } from '@mui/material';

import { SortDirection, UsageInsightSortField } from '@localstack/types';

import { ReactElement } from 'react';

import { HeaderCellProps } from './types';

export const HeaderCell = ({ column, sortBy, sortDirection, onSortChange }: HeaderCellProps): ReactElement => {
  const isSorted = column.sortField ? sortBy === column.sortField : false;

  let content = (
    <Typography variant="caption" color="text.secondary">
      {column.header}
    </Typography>
  );

  if (column.tooltip) {
    content = <Tooltip title={column.tooltip}>{content}</Tooltip>;
  }

  if (!column.sortField) {
    return content;
  }

  const nextDirection = isSorted && sortDirection === SortDirection.ASC ? SortDirection.DESC : SortDirection.ASC;

  return (
    <TableSortLabel
      active={isSorted}
      direction={isSorted ? sortDirection : SortDirection.ASC}
      onClick={() => onSortChange(column.sortField as UsageInsightSortField, nextDirection)}
    >
      {content}
    </TableSortLabel>
  );
};
